import axios from "axios";
import { ConfigHeaderBlobResponse } from "@shared/api/config";
import { registerAuthInterceptors } from "@shared/api/authInterceptor";

export const CustomAxios = axios.create({
    baseURL: "/v1/"
})

export const CustomAxiosV2 = axios.create({
    baseURL: "/v2/"
})

registerAuthInterceptors(CustomAxios, CustomAxiosV2)

export const downloadFile = (url: string, filename: string): Promise<void> => {
    return CustomAxios.get(url, ConfigHeaderBlobResponse())
        .then(({ data, headers }) => {
            const link = document.createElement("a");
            link.target = "_blank";
            link.download = filename;
            link.href = window.URL.createObjectURL(
                new Blob([data], {
                    // El header puede venir null; el cast solo silencia el tipo, el valor
                    // que recibe Blob es exactamente el mismo que antes.
                    type: headers["content-type"] as string | undefined,
                })
            );
            link.click();
        })
    }

export const showFile = (url: string): Promise<void> => {
    return CustomAxios.get(url, ConfigHeaderBlobResponse())
        .then(({ data, headers }) => {
            const blob = new Blob([data], {
                type: "application/pdf",
            });

            const objectUrl = window.URL.createObjectURL(blob);
            const windowFile = window.open(objectUrl, "_blank");

            if (!windowFile) {
                throw new Error("Failed to open popup. Please allow pop-ups for this site.");
            }

            setTimeout(() => {
                window.URL.revokeObjectURL(objectUrl);
            }, 5000);
        })
}

export const downloadFileV2 = (url: string, filename: string): Promise<void> => {
    return CustomAxiosV2.get(url, ConfigHeaderBlobResponse())
        .then(response => {
            const blob = new Blob([response.data], { type: "application/octet-stream" });
            const objectUrl = window.URL.createObjectURL(blob); // eslint-disable-line
            const windowFile = window.open(objectUrl, "_blank");

            if (!windowFile) {
                throw new Error("Failed to open popup. Please allow pop-ups for this site.");
            }

            setTimeout(() => {
                window.URL.revokeObjectURL(objectUrl);
            }, 5000);
        })
}

export const showFileV2 = (url: string): Promise<void> => {
    return CustomAxiosV2.get(url, ConfigHeaderBlobResponse())
        .then(({ data, headers }) => {
            const blob = new Blob([data], {
                type: "application/pdf",
            });

            const objectUrl = window.URL.createObjectURL(blob);
            const windowFile = window.open(objectUrl, "_blank");

            if (!windowFile) {
                throw new Error("Failed to open popup. Please allow pop-ups for this site.");
            }

            setTimeout(() => {
                window.URL.revokeObjectURL(objectUrl);
            }, 5000);
        })
}